import { Component, EventEmitter, Output, Input } from "@angular/core";
import Swal from "sweetalert2";

@Component({
  selector: "upload-image-button",
  templateUrl: "./upload-image-button.component.html",
  styleUrls: [
    "./upload-image-button.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class UploadImageButtonComponent {
  public showDiscussionImageAlert: boolean;
  public showCommunityImageAlert: boolean;
  public showAlert: boolean;
  @Input() targetObject: any;
  @Input() targetType: string;
  @Output() emitImage = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {
    this.showDiscussionImageAlert =
      this.targetType === "Discussion" && !this.targetObject.slug;

    this.showCommunityImageAlert =
      this.targetType === "Community" && !this.targetObject.id;

    this.showAlert =
      this.showDiscussionImageAlert || this.showCommunityImageAlert;
  }

  public saveImage(url) {
    this.emitImage.emit(url);
  }

  public openDiscussionImageAlert() {
    Swal.fire({
      title: "Image upload",
      text: `Please publish this ${this.targetType} first and then edit to add an image`,
      type: "info",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Ok",
    });
  }
}
